<template>
<w-sliding-popup ref="slidingPopup" title="장애티켓 처리결과" width="950px">
  <div slot="content">
    <el-row>
      <el-form label-position="top">
        <el-form-item label="처리상태">
          <el-select v-model="selectTicketStatus">
            <el-option v-for="ticketStatusInfo in ticketStatusList" :key="ticketStatusInfo.value" :label="ticketStatusInfo.label" :value="ticketStatusInfo.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="장애증상">
          <el-input type="textarea" :rows="5" v-model="formData.troubleSymptom" class="ticket-input-class"></el-input>
        </el-form-item>
        <el-form-item label="장애원인">
          <el-input type="textarea" :rows="5" v-model="formData.troubleReason" class="ticket-input-class"></el-input>
        </el-form-item>
        <el-form-item label="처리 세부 내용">
          <el-input type="textarea" :rows="5" v-model="formData.troubleTreatment" class="ticket-input-class"></el-input>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" style="margin-right: 5px;" @click="clickEventTicketReportAdd">등록</el-button>
    <el-button size="large" @click="clickCloseBtn">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import { forEach } from 'lodash';
import msgUtil from '@/utils/message';
import TroubleShootingAPI from '@/api/event/trouble-shooting';

export default {
  name: 'WEventTicketReportPopup',
  props: {
    troubleTicketGroupId: {
      type: Number,
    },
    eventList: {
      type: Array,
    },
  },
  data() {
    return {
      selectTicketStatus: 'S',
      ticketStatusList: [
        {
          value: 'F',
          label: '실패',
        },
        {
          value: 'S',
          label: '성공',
        },
      ],
      formData: {
        troubleSymptom: '',
        troubleReason: '',
        troubleTreatment: '',
      },
    };
  },
  methods: {
    clickEventTicketReportAdd() {
      const objInfoList = [];
      forEach(this.eventList, (item) => {
        objInfoList.push(item.objId);
      });
      const params = {
        objInfoList,
        troubleStatus: this.selectTicketStatus,
        troubleTicketGroupId: this.troubleTicketGroupId,
        troubleSymptom: this.formData.troubleSymptom,
        troubleReason: this.formData.troubleReason,
        troubleTreatment: this.formData.troubleTreatment,
      };
      const target = '장애 티켓';
      const action = '처리 완료';
      TroubleShootingAPI.completeTroubleShooting(params)
        .then((response) => {
          if (response.data.success) {
            this.$emit('reload');
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.clickCloseBtn();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    open() {
      // 초기화
      this.formData = {
        troubleReason: '',
        troubleSymptom: '',
        troubleTreatment: '',
      };
      this.$refs.slidingPopup.open();
    },
    // close 버튼 클릭
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/components/popup/EventTicketReportPopup.vue